const NAV_ITEMS = [
  {
    label: "Risk of Recurrence",
    path: "/adjuvant-renal-cell-carcinoma/risk-of-recurrence/",
    anchors: [
      { label: "Recurrence After Surgery", id: "Recurrence-After-Surgery" },
      { label: "Recurrence After Adjuvant Monotherapy", id: "Recurrence-After-Adjuvant-Monotherapy" },
    ],
  },
  {
    label: "Mechanisms of Action",
    path: "/adjuvant-renal-cell-carcinoma/mechanisms-of-action/",
    anchors: [
      { label: "MOA for KEYTRUDA", id: "MOA-for-KEYTRUDA" },
      { label: "MOA for WELIREG", id: "MOA-for-WELIREG" }
    ],
  },
  {
    label: "Efficacy & Safety",
    path: "/adjuvant-renal-cell-carcinoma/clinical-efficacy-and-safety/",
    anchors: [
      { label: "Efficacy", id: "Efficacy" },
      { label: "Study Design", id: "Study-Design" },
      { label: "Patient Population", id: "Patient-Population" },
      { label: "Safety", id: "Safety" },
    ],
  },
  {
    label: "Dosing",
    path: "/adjuvant-renal-cell-carcinoma/dosing/",
    anchors: [
      { label: "KEYTRUDA or KEYTRUDA QLEX Dosing", id: "KEYTRUDA-or-KEYTRUDA-QLEX-Dosing" },
      { label: "WELIREG Dosing", id: "WELIREG-Dosing" },
      { label: "WELIREG Dose Modification", id: "WELIREG-Dose-Modification" },
    ],
  },
  {
    label: "Resources & Ordering",
    path: "/adjuvant-renal-cell-carcinoma/resources-and-ordering/",
    anchors: [
      { label: "Ordering", id: "Ordering" },
      { label: "Connect with Merck", id: "Connect-With-Merck" },
    ],
  },
];

const multiHeaderCopy = {
    "mt" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-headerbg.png",
        bgImgTab: "/static/images/bgtablet.png",
        bgImgMob: "/static/images/bgmob.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"WELIREG® (belzutifan) Logo",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: true,
    },
    "default" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "rcc" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "vhl" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: false,
    },
     "ut" : {
        className: "home-welireg-header",
        bgImg: "/static/images/welireg-header-bg.png",
        bgImgTab: "/static/images/welireg-header-bg.png",
        bgImgMob: "/static/images/welireg-header-bg-mob-1.png",
        logos: [
                {
                    link: '/',
                    path:"/static/images/logos/welireg-logo-colour.svg",
                    pathMobileMenuOpened: "/static/images/logos/welireg-logo-white.svg",
                    alt:"",
                    className:"welireg-logo"
                }
            ],
            showPrimaryNav: false,
            useWhiteHamburger: true,
    },
    "arcc" : {
        className: "home-kwq-header",
        bgImg: "/static/images/keytruda-welireg-qlex-header-bg.png",
        logos:[
                {
                    link: '#',
                    path:"/static/images/logos/Key-Wel-Qlex_Horizontal_FINAL.svg",
                    pathMobileMenuOpened: "/static/images/logos/keytruda-welireg-logo-white.svg",
                    alt:"KEYTRUDA® (pembrolizumab) & WELIREG® (belzutifan) Logo",
                    className:"keytruda-qlex-logo"
                }
              ],
                // ,
                //  {
                //     link: '#',
                //     path:"/static/images/logos/keytruda-qlex-logo-colour.svg",
                //     pathMobileMenuOpened: "/static/images/logos/keytruda-qlex-logo-white.svg",
                //     alt:"KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Logo",
                //     className:"keytruda-qlex-logo"
                // }
            
        showPrimaryNav: false,
        useWhiteHamburger: false,
    }

}

export default multiHeaderCopy;